import { render } from "./TheMessage.vue?vue&type=template&id=5d78785a"
import script from "./TheMessage.vue?vue&type=script&lang=js"
export * from "./TheMessage.vue?vue&type=script&lang=js"
script.render = render

export default script